import { privateApi } from '@services/api';

const WORKER_PERSONAL_VIDEO_URL = 'worker/personal-video';

export interface SaveWorkerPersonalVideoPayload {
  s3FileId: number;
}

export interface SaveWorkerPersonalVideoResponse {
  personalVideoId: number;
}

export const saveWorkerPersonalVideo = async (
  payload: SaveWorkerPersonalVideoPayload
): Promise<SaveWorkerPersonalVideoResponse> => {
  try {
    const result = await privateApi.post<SaveWorkerPersonalVideoResponse>(
      WORKER_PERSONAL_VIDEO_URL,
      payload
    );
    return result.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const deleteWorkerPersonalVideo = async (): Promise<void> => {
  await privateApi.delete(WORKER_PERSONAL_VIDEO_URL);
};
